// @core/api/endpoints/resource/get_external_resource_by_url.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExternalResourceResponse,
} from '../../../types/resource';

const BASE_PATH = '/resource';

/**
 * Get external resource by URL
 * Looks up an external resource by its URL. Returns the resource if previously registered, or null if the URL has not been registered.
 */
export async function GetExternalResourceByURL(
  params?: {
    url?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ExternalResourceResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/external/by-url`;
  const requestOptions = options;
  return client.get<ExternalResourceResponse>(requestPath, { ...requestOptions, params });
}
